import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export async function isPushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  if (!(await isPushSupported())) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return Notification.permission === "granted" ? "granted-no-sub" : "default";
    const sub = await reg.pushManager.getSubscription();
    if (sub) return "subscribed";
    return Notification.permission === "granted" ? "granted-no-sub" : "default";
  } catch (_) { return "default"; }
}

export async function enablePush() {
  if (!(await isPushSupported())) throw new Error("Push not supported on this browser");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;

  let perm = Notification.permission;
  if (perm === "default") perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission denied");

  const { data } = await api.get("/push/vapid_public_key");
  const key = urlBase64ToUint8Array(data.key);
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const json = sub.toJSON();
    try { await api.post("/push/unsubscribe", { endpoint: json.endpoint, keys: json.keys || {} }); } catch (e) { console.warn("push/unsubscribe failed (unsubscribing locally anyway):", e); }
    await sub.unsubscribe();
  }
}
